import React from 'react';
import { SuspenseWrapper } from './SuspenseWrapper';
import { NotFoundRoute } from './NotFoundRoute';
import { useGetItemIdFromRouter } from './useGetItemIdFromRoute';
import { useFetchItem } from '../../service/areena-api/hooks/useFetchItem';
import useSWR from 'swr';
import { useAuthContext } from '../contexts/AuthContext/AuthContext';
import { getEpisodesViewFetcher } from '../../service/areena-api/fetchers';

const EpisodesRoute: React.FC = () => {
  const itemId = useGetItemIdFromRouter();
  const { data: itemViewResponse, isLoading: isItemViewLoading } =
    useFetchItem(itemId);

  const episodesUri = itemViewResponse?.data?.header?.controls?.find(control =>
    control.destination?.uri.includes('episodes')
  )?.destination?.uri;

  const { user } = useAuthContext();

  const fetcher = getEpisodesViewFetcher(Boolean(user));
  const { isLoading: isEpisodesViewLoading } = useSWR(episodesUri, fetcher);

  if (!itemId) {
    return <NotFoundRoute />; // 404
  }

  return (
    <SuspenseWrapper isLoading={isItemViewLoading || isEpisodesViewLoading}>
      <AuthRequired>
        <EpisodesComponent itemId={itemId} />
      </AuthRequired>
    </SuspenseWrapper>
  );
};

const EpisodesComponent = React.lazy(() => import('../Episodes/Episodes'));
const AuthRequired = React.lazy(() => import('./redirects/AuthRedirect'));

export default EpisodesRoute;
